export function defMelevenArticleImageUrl(imageSrc: string, defaultResolution: string, resolution: string) {
    return imageSrc.replace(defaultResolution, resolution);
}
